import {
	doFormValidation,
	doDateFieldValidation,
	onFieldInput,
	onSelectChange,
	removeError,
	scrollToFirstError
} from '../lib/forms';

let forms;

let formAction = '/include/ajax/form-children-profile.php';
let formPage = '/personal/parent-and-child/';

const init = () => {
	forms = document.querySelectorAll('.js-children-profile-form');
	if (forms.length <= 0) return;


	// do scroll on page loaded
	let urlParams = new URL(document.location).searchParams;
	let scrollToMessage = urlParams.get('child_success') !== null;
	let scrollToForm = urlParams.get('add_child') !== null;

	if (scrollToMessage || scrollToForm) {

		let targetBlock = document.querySelector((scrollToMessage ? '.profile__section' : '.js-children-profile-new-form'));
		let targetTop = null;

		if (targetBlock) {
			let targetBlockBox = targetBlock.getBoundingClientRect();
			targetTop = targetBlockBox.top + window.pageYOffset - (window.screen.width >= 768 ? 81 : 72);
		}

		if (targetTop !== null) {
			setTimeout(
				() => {
					window.scrollTo({
						left: 0,
						top: targetTop,
						behavior: "smooth"
					})
				},
				900
			);
		}
	}

	// Profile accordion
	if (window.accordion) {
		document.querySelectorAll(`.profile__children-list > .accordion`)
			.forEach((accordion) => {
				window.accordion.init(accordion);
			});
	}

	let fieldsRequired = [
		'profile-lastname',
		'profile-name',
		'profile-gender',
		'profile-school',
		'profile-grade',
		'profile-school-address'
	];

	forms.forEach((form) => {

		fieldsRequired.forEach((fieldCode) => {
			let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
			if (!fieldElement) return;

			if (fieldElement.type === 'select-one') {
				fieldElement.addEventListener('change', onSelectChange);
			}
			else {
				fieldElement.addEventListener('input', onFieldInput);
			}
		});

		let dateInput = form.querySelector('[name="profile-birthday"]');
		if (dateInput && dateInput.dateMask) {
			dateInput.dateMask.on('accept', function() {
				if (dateInput.dateMask.typedValue !== null) {
					removeError(dateInput);
				}
			});
		}

		// submit
		let accordionOuter = form.closest('.accordion__outer');
		let overlayElem = form.querySelector('.form__overlay');

		form.addEventListener('submit', (e) => {
			e.preventDefault();

			if (accordionOuter) accordionOuter.style.maxHeight = 'initial';

			let fieldsChecked = doFormValidation(form, fieldsRequired, e);
			let dateChecked = doDateFieldValidation(form, 'profile-birthday', e);

			if (!fieldsChecked || !dateChecked) {
				scrollToFirstError(form);
				return;
			}

			let formData = new FormData(form);
			formData.set('action', 'save');

			if (overlayElem) {
				overlayElem.style.display = 'block';
			}

			fetch(formAction, {
				method: 'POST',
				body: formData
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((result) => {
					if (result.error) {
						throw new Error(result.message);
					}
					window.location = formPage + '?child_success=y';
				})
				.catch((error) => {
					if (overlayElem) {
						overlayElem.style.display = 'none';
					}
					alert(error.message);
				});
		});

		// delete
		let deleteButton = form.querySelector('.js-children-profile-delete');
		if (deleteButton) {
			deleteButton.addEventListener('click', (e) => {
				if (window.confirm("Удалить данные этого ребёнка из вашего профиля?")) {

					let formData = new FormData(form);
					formData.set('action', 'delete');

					if (overlayElem) {
						overlayElem.style.display = 'block';
					}

					fetch(formAction, {
						method: 'POST',
						body: formData
					})
						.then((response) => {
							if (!response.ok) {
								throw new Error(`HTTP error! Status: ${response.status}`);
							}
							return response.json();
						})
						.then((result) => {
							if (result.error) {
								throw new Error(result.message);
							}
							window.location = formPage + '?child_success=y';
						})
						.catch((error) => {
							if (overlayElem) {
								overlayElem.style.display = 'none';
							}
							alert(error.message);
						});
				}
			});
		}

		// reset
		form.addEventListener('reset', (e) => {
			let allFieldsRequired = fieldsRequired.concat('profile-birthday');

			allFieldsRequired.forEach((fieldCode) => {
				let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
				if (!fieldElement) return;

				removeError(fieldElement);
			});
		});
	});


	// add one more form
	let addMoreButton = document.querySelector('.js-children-profile-add-more');
	if (addMoreButton) {
		addMoreButton.addEventListener('click', (e) => {
			window.location = formPage + '?add_child=y';
		});
	}
};

export default {
	init
};